export function LogoMark({ size = 38 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
            <rect width="48" height="48" rx="11" fill="#111C2E" />
            <path
                d="M15 11h12a7.5 7.5 0 0 1 4.6 13.4A8 8 0 0 1 28 39H15V11z"
                fill="none"
                stroke="#FF5A36"
                strokeWidth="4.5"
                strokeLinejoin="round"
            />
            <path d="M19 25.5h8" stroke="#38BDF8" strokeWidth="4.5" strokeLinecap="round" />
            <circle cx="39" cy="39" r="3.2" fill="#00F0FF" />
        </svg>
    );
}

export default function Logo({ compact = false }) {
    return (
        <span className="inline-flex items-center gap-3">
            <LogoMark />
            <span className="leading-none">
                <span className="font-display block text-lg font-extrabold tracking-tight text-slate-50">
                    B&amp;B <span className="text-coral">Painting</span>
                </span>
                {!compact && (
                    <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400">
                        Renovation · Toronto
                    </span>
                )}
            </span>
        </span>
    );
}